'use strict';

// Maps each country to its most popular language
// Auto-generated:
// 1. var data = fetch('https://raw.githubusercontent.com/annexare/Countries/master/countries.json')
// 2. _(data.countries).mapValues(function(value) { return value.languages.split(',')[0] }).each(function(language, countryCode) {console.log(''' + countryCode + '': '' + language + '',')}).value()
// 3. Set 'MY' to 'ms'
// 4. Remove countries with empty languages (AQ, BV)
// 5. Set 'NO' and 'SJ' to 'nb'

Object.defineProperty(exports, "__esModule", {
	value: true
});
var languages = exports.languages = {
	'AD': 'ca',
	'AE': 'ar',
	'AF': 'ps',
	'AG': 'en',
	'AI': 'en',
	'AL': 'sq',
	'AM': 'hy',
	'AO': 'pt',
	'AR': 'es',
	'AS': 'en',
	'AT': 'de',
	'AU': 'en',
	'AW': 'nl',
	'AX': 'sv',
	'AZ': 'az',
	'BA': 'bs',
	'BB': 'en',
	'BD': 'bn',
	'BE': 'nl',
	'BF': 'fr',
	'BG': 'bg',
	'BH': 'ar',
	'BI': 'fr',
	'BJ': 'fr',
	'BL': 'fr',
	'BM': 'en',
	'BN': 'ms',
	'BO': 'es',
	'BQ': 'nl',
	'BR': 'pt',
	'BS': 'en',
	'BT': 'dz',
	'BW': 'en',
	'BY': 'be',
	'BZ': 'en',
	'CA': 'en',
	'CC': 'en',
	'CD': 'fr',
	'CF': 'fr',
	'CG': 'fr',
	'CH': 'de',
	'CI': 'fr',
	'CK': 'en',
	'CL': 'es',
	'CM': 'en',
	'CN': 'zh',
	'CO': 'es',
	'CR': 'es',
	'CU': 'es',
	'CV': 'pt',
	'CW': 'nl',
	'CX': 'en',
	'CY': 'el',
	'CZ': 'cs',
	'DE': 'de',
	'DJ': 'fr',
	'DK': 'da',
	'DM': 'en',
	'DO': 'es',
	'DZ': 'ar',
	'EC': 'es',
	'EE': 'et',
	'EG': 'ar',
	'EH': 'es',
	'ER': 'ti',
	'ES': 'es',
	'ET': 'am',
	'FI': 'fi',
	'FJ': 'en',
	'FK': 'en',
	'FM': 'en',
	'FO': 'fo',
	'FR': 'fr',
	'GA': 'fr',
	'GB': 'en',
	'GD': 'en',
	'GE': 'ka',
	'GF': 'fr',
	'GG': 'en',
	'GH': 'en',
	'GI': 'en',
	'GL': 'kl',
	'GM': 'en',
	'GN': 'fr',
	'GP': 'fr',
	'GQ': 'es',
	'GR': 'el',
	'GS': 'en',
	'GT': 'es',
	'GU': 'en',
	'GW': 'pt',
	'GY': 'en',
	'HK': 'zh',
	'HM': 'en',
	'HN': 'es',
	'HR': 'hr',
	'HT': 'fr',
	'HU': 'hu',
	'ID': 'id',
	'IE': 'ga',
	'IL': 'he',
	'IM': 'en',
	'IN': 'hi',
	'IO': 'en',
	'IQ': 'ar',
	'IR': 'fa',
	'IS': 'is',
	'IT': 'it',
	'JE': 'en',
	'JM': 'en',
	'JO': 'ar',
	'JP': 'ja',
	'KE': 'en',
	'KG': 'ky',
	'KH': 'km',
	'KI': 'en',
	'KM': 'ar',
	'KN': 'en',
	'KP': 'ko',
	'KR': 'ko',
	'KW': 'ar',
	'KY': 'en',
	'KZ': 'kk',
	'LA': 'lo',
	'LB': 'ar',
	'LC': 'en',
	'LI': 'de',
	'LK': 'si',
	'LR': 'en',
	'LS': 'en',
	'LT': 'lt',
	'LU': 'fr',
	'LV': 'lv',
	'LY': 'ar',
	'MA': 'ar',
	'MC': 'fr',
	'MD': 'ro',
	'ME': 'sr',
	'MF': 'en',
	'MG': 'fr',
	'MH': 'en',
	'MK': 'mk',
	'ML': 'fr',
	'MM': 'my',
	'MN': 'mn',
	'MO': 'zh',
	'MP': 'en',
	'MQ': 'fr',
	'MR': 'ar',
	'MS': 'en',
	'MT': 'mt',
	'MU': 'en',
	'MV': 'dv',
	'MW': 'en',
	'MX': 'es',
	'MY': 'ms',
	'MZ': 'pt',
	'NA': 'en',
	'NC': 'fr',
	'NE': 'fr',
	'NF': 'en',
	'NG': 'en',
	'NI': 'es',
	'NL': 'nl',
	'NO': 'nb',
	'NP': 'ne',
	'NR': 'en',
	'NU': 'en',
	'NZ': 'en',
	'OM': 'ar',
	'PA': 'es',
	'PE': 'es',
	'PF': 'fr',
	'PG': 'en',
	'PH': 'en',
	'PK': 'en',
	'PL': 'pl',
	'PM': 'fr',
	'PN': 'en',
	'PR': 'es',
	'PS': 'ar',
	'PT': 'pt',
	'PW': 'en',
	'PY': 'es',
	'QA': 'ar',
	'RE': 'fr',
	'RO': 'ro',
	'RS': 'sr',
	'RU': 'ru',
	'RW': 'rw',
	'SA': 'ar',
	'SB': 'en',
	'SC': 'fr',
	'SD': 'ar',
	'SE': 'sv',
	'SG': 'en',
	'SH': 'en',
	'SI': 'sl',
	'SJ': 'nb',
	'SK': 'sk',
	'SL': 'en',
	'SM': 'it',
	'SN': 'fr',
	'SO': 'so',
	'SR': 'nl',
	'SS': 'en',
	'ST': 'pt',
	'SV': 'es',
	'SX': 'nl',
	'SY': 'ar',
	'SZ': 'en',
	'TC': 'en',
	'TD': 'fr',
	'TF': 'fr',
	'TG': 'fr',
	'TH': 'th',
	'TJ': 'tg',
	'TK': 'en',
	'TL': 'pt',
	'TM': 'tk',
	'TN': 'ar',
	'TO': 'en',
	'TR': 'tr',
	'TT': 'en',
	'TV': 'en',
	'TW': 'zh',
	'TZ': 'sw',
	'UA': 'uk',
	'UG': 'en',
	'UM': 'en',
	'US': 'en',
	'UY': 'es',
	'UZ': 'uz',
	'VA': 'it',
	'VC': 'en',
	'VE': 'es',
	'VG': 'en',
	'VI': 'en',
	'VN': 'vi',
	'VU': 'bi',
	'WF': 'fr',
	'WS': 'sm',
	'XK': 'sq',
	'YE': 'ar',
	'YT': 'fr',
	'ZA': 'af',
	'ZM': 'en',
	'ZW': 'en'
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/locale-helpers/dist/Countries.js
// module id = 1423
// module chunks = 0